import { namedWeb3Errors } from '../../constants';
import { trackAndNotifyTransactionStatus } from './trackAndNotifyTransactionStatus';

// TODO: Remove side effect of "Toast" from trackAndNotifyTransactionStatus and .tsx -> .ts, and make smth like handleTransactionResultWithToast
export const handleTransactionResult = async (
  ...params: Parameters<typeof trackAndNotifyTransactionStatus>
) => {
  const receipt = await trackAndNotifyTransactionStatus(...params);

  if (![1, 'success'].includes(receipt?.status as string | number)) {
    throw new Error(namedWeb3Errors.TRANSACTION_FAILED);
  }

  return receipt;
};
